function FormulaSelector(props) {
  const { typeSurebet, setTypeSurebet, calculatreBonusBookmakerAndSurebet, managerCalcRiskFreeBettingFormula, calcNormalSurebetBudgetAdjusted, manageSurebetLockedValueFormula } = props;
  return (
        <>
        <label className='d-flex'>

            <input
                className="form-check-input"
                type="checkbox"
                checked={typeSurebet === "bonus_bookmaker"}
                onChange={() => {
                    if (typeSurebet !== "bonus_bookmaker") {
                        setTypeSurebet("bonus_bookmaker");
                        calculatreBonusBookmakerAndSurebet();
                        
                    }
                    else {
                        setTypeSurebet("");
                        calcNormalSurebetBudgetAdjusted();
                    }
                }
                }
            />

            <p className='ms-2'>Casa de Aposta Bônus</p>
        </label>



        <label className='d-flex'>

            <input
                className="form-check-input"
                type="checkbox"
                checked={typeSurebet === "risk_free_betting"}
                onChange={() => {
                    if (typeSurebet !== "risk_free_betting") {
                        setTypeSurebet("risk_free_betting");
                        managerCalcRiskFreeBettingFormula();
                        
                    }
                    else {
                        setTypeSurebet("");
                        calcNormalSurebetBudgetAdjusted();
                    }
                }
                }
            />

            <p className='ms-2'>Aposta Sem Risco</p>
        </label>

        <label className='d-flex'>

            <input
                className="form-check-input"
                type="checkbox"
                checked={typeSurebet === "locked_value"}
                onChange={() => {
                    if (typeSurebet !== "locked_value") {
                        setTypeSurebet("locked_value");
                        manageSurebetLockedValueFormula();
                        
                    }
                    else {
                        setTypeSurebet("");
                        calcNormalSurebetBudgetAdjusted();
                    }
                }
                }
            />

            <p className='ms-2'>Modo Valor Travado</p>
        </label>


        </>
    );
}
export {
  FormulaSelector
};